import css from './index.module.scss';

export default function BundlePopup({ bundlePopupKey, callback }: any) {
    const lists = [
        {
            title: bundlePopupKey === 1 ? 'Step 1: Order Placement' : bundlePopupKey === 2 ? 'Step 1: Order Placement + Basic installation fee' : '',
            desc: 'Please provide your personal information when placing the order.',
            icon: (
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20.667 6.66797H22.667C24.1398 6.66797 25.3337 7.86188 25.3337 9.33464V25.3346C25.3337 26.8074 24.1398 28.0013 22.667 28.0013H9.33366C7.8609 28.0013 6.66699 26.8074 6.66699 25.3346V9.33464C6.66699 7.86188 7.8609 6.66797 9.33366 6.66797H11.3337"
                        stroke="#7293F7"
                        strokeWidth="1.53846"
                    />
                    <path d="M12 18.2456L15.0877 21.3333L20.4211 16" stroke="#7293F7" strokeWidth="1.53846" />
                    <path
                        d="M11.307 5.33333C11.307 4.95042 11.6174 4.64 12.0003 4.64H20.0003C20.3832 4.64 20.6937 4.95042 20.6937 5.33333V8C20.6937 8.38292 20.3832 8.69333 20.0003 8.69333H12.0003C11.6174 8.69333 11.307 8.38292 11.307 8V5.33333Z"
                        stroke="#7293F7"
                        strokeWidth="1.28"
                    />
                </svg>
            ),
        },
        {
            title: 'Step 2: Schedule Installation',
            desc: 'Our team will contact you within 2 business days via phone call to confirm the installation schedule.',
            icon: (
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M24.2969 5.33594H7.70435C6.39524 5.33594 5.33398 6.39719 5.33398 7.70631V24.2989C5.33398 25.608 6.39524 26.6693 7.70435 26.6693H24.2969C25.6061 26.6693 26.6673 25.608 26.6673 24.2989V7.70631C26.6673 6.39719 25.6061 5.33594 24.2969 5.33594Z"
                        stroke="#7293F7"
                        strokeWidth="1.53846"
                    />
                    <path
                        d="M16.0001 16.5939C17.6365 16.5939 18.963 15.2673 18.963 13.6309C18.963 11.9945 17.6365 10.668 16.0001 10.668C14.3637 10.668 13.0371 11.9945 13.0371 13.6309C13.0371 15.2673 14.3637 16.5939 16.0001 16.5939Z"
                        stroke="#7293F7"
                        strokeWidth="1.53846"
                    />
                    <path
                        d="M21.3337 22.5247C21.3337 19.5792 18.9458 17.1914 16.0003 17.1914C13.0548 17.1914 10.667 19.5792 10.667 22.5247"
                        stroke="#7293F7"
                        strokeWidth="1.53846"
                        strokeLinecap="round"
                    />
                </svg>
            ),
        },
        {
            title:
                bundlePopupKey === 1
                    ? 'Step 3: Installation by Electrician + Pay Installation Fee'
                    : bundlePopupKey === 2
                    ? 'Step 3: Installation by Electrician'
                    : '',
            desc:
                bundlePopupKey === 1
                    ? 'A certified electrician will provide an evaluated installation solution, perform the installation, and issue an invoice.'
                    : bundlePopupKey === 2
                    ? 'A certified electrician will perform the installation.'
                    : '',
            icon: (
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_9877_29487)">
                        <path
                            d="M15.2259 5.15621C17.3365 7.26673 17.3365 10.6886 15.2259 12.7991C14.5805 13.4445 13.8125 13.8925 12.9968 14.1432L12.9968 27.8855L9.81223 27.8855V14.1432C8.99654 13.8925 8.22846 13.4445 7.58305 12.7991C5.47252 10.6886 5.47253 7.26673 7.58305 5.1562C8.22846 4.51079 8.99653 4.06275 9.81223 3.81207L9.81223 8.6592L12.9968 8.6592L12.9968 3.81207C13.8125 4.06276 14.5805 4.51079 15.2259 5.15621Z"
                            stroke="#7293F7"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M20 16.6667C20 16.2985 20.2985 16 20.6667 16H24.6667C25.0349 16 25.3333 16.2985 25.3333 16.6667V27.3333C25.3333 27.7015 25.0349 28 24.6667 28H20.6667C20.2985 28 20 27.7015 20 27.3333V16.6667Z"
                            stroke="#7293F7"
                            strokeWidth="1.33333"
                        />
                        <path
                            d="M21.0667 8.8V16H24.2667V8.8L25.3333 7.2L24.2667 4H21.0667L20 7.2L21.0667 8.8Z"
                            stroke="#7293F7"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_9877_29487">
                            <rect width="32" height="32" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            title: 'Step 4: Share Your Feedback',
            desc: 'We would love to hear your thoughts. Tell us about your experience!',
            icon: (
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.5499 5.19797H12.4492C11.9797 5.19797 11.599 5.57861 11.599 6.04815V7.46826C11.599 7.9378 11.9797 8.31844 12.4492 8.31844H19.5499C20.0194 8.31844 20.4 7.9378 20.4 7.46826V6.04815C20.4 5.57861 20.0194 5.19797 19.5499 5.19797ZM12.4492 3.91797C11.2927 3.91797 10.3514 4.83966 10.3199 5.98858H8.89951C6.90606 5.98858 5.29004 7.6046 5.29004 9.59805V24.5093C5.29004 26.5027 6.90605 28.1188 8.89951 28.1188H23.1008C25.0942 28.1188 26.7103 26.5027 26.7103 24.5093V9.59806C26.7103 7.6046 25.0942 5.98858 23.1008 5.98858H21.6792C21.6477 4.83966 20.7064 3.91797 19.5499 3.91797H12.4492ZM8.89951 7.52704H10.3198C10.351 8.67633 11.2924 9.59844 12.4492 9.59844H19.5499C20.7067 9.59844 21.6481 8.67633 21.6792 7.52704H23.1008C24.2446 7.52704 25.1718 8.45427 25.1718 9.59806V24.5093C25.1718 25.6531 24.2446 26.5803 23.1008 26.5803H8.89951C7.75572 26.5803 6.8285 25.6531 6.8285 24.5093V9.59805C6.8285 8.45427 7.75573 7.52704 8.89951 7.52704ZM11.0281 13.1484C10.636 13.1484 10.3181 13.4663 10.3181 13.8585C10.3181 14.2507 10.636 14.5686 11.0281 14.5686H20.969C21.3612 14.5686 21.6791 14.2507 21.6791 13.8585C21.6791 13.4663 21.3612 13.1484 20.969 13.1484H11.0281ZM10.3181 17.4093C10.3181 17.0171 10.636 16.6992 11.0281 16.6992H17.4187C17.8108 16.6992 18.1288 17.0171 18.1288 17.4093C18.1288 17.8014 17.8108 18.1193 17.4187 18.1193H11.0281C10.636 18.1193 10.3181 17.8014 10.3181 17.4093ZM11.0291 20.25C10.6369 20.25 10.319 20.5679 10.319 20.9601C10.319 21.3522 10.6369 21.6701 11.0291 21.6701H15.2895C15.6816 21.6701 15.9995 21.3522 15.9995 20.9601C15.9995 20.5679 15.6816 20.25 15.2895 20.25H11.0291Z"
                        fill="#7293F7"
                    />
                </svg>
            ),
        },
    ];

    return (
        <div className={`bundle-popup ${css['bundle-popup']}`}>
            <div className="pop-box">
                <div className="pop-header">
                    <p className="header-title">How does it work?</p>
                    <span className="header-close" onClick={callback}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>
                <ul className="pop-content">
                    {lists?.map((list: any, k: number) => (
                        <li className="list" key={k}>
                            <div className="list-icon">{list.icon}</div>
                            <div className="list-info">
                                <p className="list-title">{list.title}</p>
                                <p className="list-desc">{list.desc}</p>
                            </div>
                        </li>
                    ))}
                    <p className="pop-tip">{'*Check the detailed Terms and Conditons at the bottom of Product page.'}</p>
                    {/* <div className="wrapper"> */}
                    <table className="table">
                        <tbody className="tbody">
                            <tr className="tr">
                                <td className="td"></td>
                                <td className="td">Intelligent Kit</td>
                                <td className="td">Hassle-Free Kit</td>
                            </tr>
                            <tr className="tr">
                                <td className="td">Service Program</td>
                                <td className="td">Pay after Consulting</td>
                                <td className="td">Pay before Consulting</td>
                            </tr>
                            <tr className="tr">
                                <td className="td">Payment to</td>
                                <td className="td">Certified Electrician</td>
                                <td className="td">EcoFlow Official Website</td>
                            </tr>
                            <tr className="tr">
                                <td className="td">Service Area</td>
                                <td className="td">All of the USA</td>
                                <td className="td">Limited Regions</td>
                            </tr>
                            <tr className="tr">
                                <td className="td">Basic Service Costs</td>
                                <td className="td">Non-fixed</td>
                                <td className="td">Fixed</td>
                            </tr>
                            <tr className="tr">
                                <td className="td">Advantages</td>
                                <td className="td">
                                    <ul className="ul">
                                        <li className="li">Expertise: Our certified licensed electricians ensure top-notch installation services.</li>
                                        <li className="li">
                                            Comprehensive Service: Enjoy full-process support from order placement to installation completion, guaranteeing a
                                            seamless experience.
                                        </li>
                                    </ul>
                                </td>
                                <td className="td">
                                    <ul className="ul">
                                        <li className="li">Affordability: Save around $1000 compared to standard licensed electrician rates.</li>
                                        <li className="li">Expertise: Our certified licensed electricians ensure top-notch installation services.</li>
                                        <li className="li">
                                            Comprehensive Service: Enjoy full-process support from order placement to installation completion, guaranteeing a
                                            seamless experience.
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {/* </div> */}
                </ul>
            </div>
            <style global jsx>
                {`
                    .ecoflow-frame-header {
                        z-index: 100 !important;
                    }
                `}
            </style>
        </div>
    );
}
